// removed by extract-text-webpack-plugin
module.exports = {"name":"c-ProductName__name","link":"c-ProductName__link","big":"c-ProductName__big","noClickable":"c-ProductName__noClickable"};